import React, { Component } from 'react';
import classNames from 'classnames';
import shallowEqual from 'lodash/isEqual';
import RcCheckbox from '../rc-components/checkbox';
import RadioContext from './RadioContext';
export default class Radio extends Component {
    constructor() {
        super(...arguments);
        this.saveCheckbox = (node) => {
            this.rcCheckbox = node;
        };
        this.onChange = (e) => {
            const { onChange } = this.props;
            const { radioGroup } = this.context;
            if (onChange) {
                onChange(e);
            }
            if (radioGroup && radioGroup.onChange) {
                radioGroup.onChange(e);
            }
        };
    }
    static get contextType() {
        return RadioContext;
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const { radioGroup, getPrefixCls } = this.context;
        return (!shallowEqual(this.props, nextProps) ||
            !shallowEqual(this.state, nextState) ||
            !shallowEqual(radioGroup, nextContext.radioGroup) || getPrefixCls !== nextContext.getPrefixCls);
    }
    focus() {
        this.rcCheckbox.focus();
    }
    blur() {
        this.rcCheckbox.blur();
    }
    render() {
        const { props, context } = this;
        const { prefixCls: customizePrefixCls, className, children, style, ...restProps } = props;
        const { radioGroup, getPrefixCls } = context;
        const prefixCls = getPrefixCls('radio', customizePrefixCls);
        const radioProps = { ...restProps };
        if (radioGroup) {
            radioProps.name = radioGroup.name;
            radioProps.onChange = this.onChange;
            radioProps.checked = props.value === radioGroup.value;
            radioProps.disabled = props.disabled || radioGroup.disabled;
        }
        const wrapperClassString = classNames(className, {
            [`${prefixCls}-wrapper`]: true,
            [`${prefixCls}-wrapper-checked`]: radioProps.checked,
            [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
        });
        return (React.createElement("label", { className: wrapperClassString, style: style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave },
            React.createElement(RcCheckbox, Object.assign({}, radioProps, { prefixCls: prefixCls, ref: this.saveCheckbox })),
            children !== undefined ? React.createElement("span", null, children) : null));
    }
}
Radio.displayName = 'Radio';
Radio.defaultProps = {
    type: 'radio',
};
